import InventoryAnswers from "./Components/InventoryAnswers";

export default InventoryAnswers;
